import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FeatureName } from '../../features/FeatureName';
import { TranslatedHtmlContent } from './FeatureCell';
import { IncludesFeatureIcon } from './IncludesFeatureIcon';
import { TableCellWrapperWithHoverTracking } from './TableCellWrapperWithHoverTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ParentFeatureRow = ({
  feature,
  productApiNames,
  trackingProperties
}) => {
  return /*#__PURE__*/_jsxs(View, {
    as: "tr",
    children: [/*#__PURE__*/_jsx(TableCellWrapperWithHoverTracking, {
      trackingProperties: Object.assign({}, trackingProperties, {
        tableColumn: 'displayName'
      }),
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "right",
        title: /*#__PURE__*/_jsx(TranslatedHtmlContent, {
          htmlContent: feature.featureDescription.featureDescription
        }),
        children: /*#__PURE__*/_jsx(View, {
          paddingInlineEnd: "100",
          children: /*#__PURE__*/_jsx(FeatureName, {
            featureDisplayName: feature.displayName,
            isBeta: feature.isBeta,
            textStyles: {
              typography: 'heading-50'
            }
          })
        })
      })
    }), productApiNames.map(apiName => {
      var _feature$featureDescr;
      const limitDescriptionByProduct = (_feature$featureDescr = feature.featureDescription.limitDescriptions.limitDescriptionsByProduct) === null || _feature$featureDescr === void 0 ? void 0 : _feature$featureDescr[apiName];
      return /*#__PURE__*/_jsx(View, {
        as: "td",
        children: !feature.associatedProducts.includes(apiName) ? undefined : limitDescriptionByProduct ? /*#__PURE__*/_jsx(TranslatedHtmlContent, {
          htmlContent: limitDescriptionByProduct
        }) : /*#__PURE__*/_jsx(IncludesFeatureIcon, {})
      }, apiName);
    })]
  });
};